import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span
              className={`text-xl md:text-2xl font-heading font-bold tracking-tight transition-colors duration-300 ${
                isScrolled ? 'text-foreground-950' : 'text-white'
              }`}
            >
              韩国漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                isScrolled
                  ? 'text-foreground-800 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/romance"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                isScrolled
                  ? 'text-foreground-800 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/category/action"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                isScrolled
                  ? 'text-foreground-800 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              热门排行
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                isScrolled
                  ? 'text-foreground-800 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              关于我们
            </Link>
            <div className="relative ml-2">
              <input
                type="text"
                placeholder="搜索漫画..."
                className={`pl-9 pr-4 py-2 rounded-full text-sm border transition-all duration-300 w-48 focus:w-64 focus:outline-none ${
                  isScrolled
                    ? 'bg-background-100 border-background-200 text-foreground-800 placeholder:text-foreground-400 focus:border-primary-300'
                    : 'bg-white/15 border-white/20 text-white placeholder:text-white/50 focus:border-white/50 focus:bg-white/25'
                }`}
              />
              <i
                className={`ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm ${
                  isScrolled ? 'text-foreground-400' : 'text-white/60'
                }`}
              ></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-xl transition-colors duration-300 ${
                isScrolled ? 'text-foreground-800' : 'text-white'
              } ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <div className="flex flex-col gap-3">
            <Link
              to="/"
              className="text-sm text-foreground-800 font-medium py-2"
              onClick={() => setIsMobileOpen(false)}
            >
              首页
            </Link>
            <Link
              to="/category/romance"
              className="text-sm text-foreground-800 font-medium py-2"
              onClick={() => setIsMobileOpen(false)}
            >
              分类浏览
            </Link>
            <Link
              to="/category/action"
              className="text-sm text-foreground-800 font-medium py-2"
              onClick={() => setIsMobileOpen(false)}
            >
              热门排行
            </Link>
            <Link
              to="/about"
              className="text-sm text-foreground-800 font-medium py-2"
              onClick={() => setIsMobileOpen(false)}
            >
              关于我们
            </Link>
            <div className="relative mt-1">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full pl-9 pr-4 py-2 rounded-full text-sm border border-background-200 bg-background-100 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}